


























import TitleBar from '@/modules/core/components/TitleBar.vue';
import Tiles from '@/modules/core/components/Tiles.vue';
import CardWidget from '@/modules/core/components/CardWidget.vue';
import CardComponent from '@/modules/core/components/CardComponent.vue';
import AlertsTable from '@/modules/alert/components/AlertsTable.vue';
import TechnicalMessagesTable from '@/modules/technical-message/components/TechnicalMessagesTable.vue';
import BreadcrumbsTable from '@/modules/breadcrumb/components/BreadcrumbsTable.vue';
import Device from '../components/Device.vue';
import { deviceApi } from '../device.api';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    TitleBar,
    Tiles,
    Device,
    CardWidget,
    CardComponent,
    AlertsTable,
    TechnicalMessagesTable,
    BreadcrumbsTable,
  },
})
export default class DeviceView extends Vue {
  public device: any = null;

  public get titleStack(): string[] {
    if (!this.device) {
      return [];
    }

    return ['Admin', 'Terminal', this.device.incrementalId];
  }

  public get deviceId(): string {
    return this.$route.params.id;
  }

  public async getDevice(): Promise<void> {
    this.device = await deviceApi.get(this.deviceId);
  }

  public mounted(): void {
    this.getDevice();
  }
}
